 <h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">

  <form class="form-wrapper" [formGroup]="projektForm" autocomplete=off>

    <div class="eineLinie">


      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.name' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.name' | translate"
          formControlName="name"
        />
        <mat-error *ngIf="projektForm.controls.name.invalid">{{ getErrorMessage('name') | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="shortField" appearance="outline">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.mitarbeiter' | translate }}</mat-label>
        <mat-select #mySel formControlName="mitarbeiter" multiple>
          <mat-option (click)="toggleAllSelection()" [value]="0">Alle</mat-option>
          <mat-option *ngFor="let mitarbeiter of ($mitarbeiter |async)" [value]="mitarbeiter.id" >
            {{mitarbeiter.name + " " + mitarbeiter.vorname + "  " + mitarbeiter.plz + " "  + mitarbeiter.ort }}
          </mat-option>
          <div class="row no-gutters pb-1 buttonPlacement">
              <button
                mat-raised-button
                color="accent"
                (click)="okClicked()"
              >
                {{ data.submitButtonLabel | translate }}
              </button>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <ng-container *ngIf="showDetails">

    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.projektverwaltung.projektDialog.adr1' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.projektverwaltung.projektDialog.adr1' | translate"
        formControlName="str1"
      />
      <mat-error *ngIf="projektForm.controls.str1.invalid">{{ getErrorMessage('str1') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.projektverwaltung.projektDialog.adr2' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.projektverwaltung.projektDialog.adr2' | translate"
        formControlName="str2"
      />
      <mat-error *ngIf="projektForm.controls.str2.invalid">{{ getErrorMessage('str2') | translate }}</mat-error>
    </mat-form-field></div>
    <div class="eineLinie">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.plz' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.plz' | translate"
          formControlName="plz"
          [evenNumbersOnlyMax]=9999
          onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off
        />
        <mat-error *ngIf="projektForm.controls.plz.invalid">{{ getErrorMessage('plz') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.ort' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.ort' | translate"
          formControlName="ort"
        />
        <mat-error *ngIf="projektForm.controls.ort.invalid">{{ getErrorMessage('ort') | translate }}</mat-error>
      </mat-form-field>
</div>
    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.projektverwaltung.projektDialog.start' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.projektverwaltung.projektDialog.start' | translate"
        [matDatepicker]="picker"
        formControlName="start"
      />
      <mat-datepicker-toggle     [tabIndex]="-1" matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="projektForm.controls.start.invalid"></mat-error>
    </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.ende' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.ende' | translate"
          [matDatepicker]="endepicker"
          formControlName="ende"
        />
        <mat-datepicker-toggle    [tabIndex]="-1" matSuffix [for]="endepicker"></mat-datepicker-toggle>
        <mat-datepicker #endepicker></mat-datepicker>
        <mat-error *ngIf="projektForm.controls.ende.invalid"></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.nummer' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.nummer' | translate"
          formControlName="nummer">
        <mat-error *ngIf="projektForm.controls.nummer.invalid">{{ getErrorMessage('nummer') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.beschreibung' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.beschreibung' | translate"
          formControlName="beschreibung">
        <mat-error *ngIf="projektForm.controls.beschreibung.invalid">{{ getErrorMessage('beschreibung') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.auftraggeber' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.auftraggeber' | translate"
          formControlName="auftraggeber">
        <mat-error *ngIf="projektForm.controls.auftraggeber.invalid">{{ getErrorMessage('auftraggeber') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.abteilung' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.abteilung' | translate"
          formControlName="abteilung">
        <mat-error *ngIf="projektForm.controls.abteilung.invalid">{{ getErrorMessage('abteilung') | translate }}</mat-error>
      </mat-form-field>
      <mat-radio-group formControlName="verrechnen">
        <mat-radio-button  class="radioButton" value="1">{{ 'pages.timeDialog.verrechnen' | translate }}</mat-radio-button>
        <mat-radio-button  class="radioButton" value="0">{{ 'pages.timeDialog.niverbar' | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>
    </ng-container>
    <div *ngIf="!showDetails">
    <button
      [ngStyle]="{'margin-left': '20px'}"
      class="abbruch"

      color="accent"
      (click)="showDetails = true"
      [tabIndex]="-1"
    >
      {{ 'pages.projektverwaltung.projektDialog.showDetails' | translate }}
    </button>

      <mat-radio-group formControlName="verrechnen">
        <mat-radio-button  class="radioButton" value="1">{{ 'pages.timeDialog.verrechnen' | translate }}</mat-radio-button>
        <mat-radio-button  class="radioButton" value="0">{{ 'pages.timeDialog.niverbar' | translate }}</mat-radio-button>
      </mat-radio-group>

    </div>


  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="abbruch"
    color="accent"
    (click)="handleCancelClick()"
    [tabIndex]="-1"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="projektForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>

</mat-dialog-actions>
